<template>
  <header :class="{ floating : scrolled, dark: isAIActive(), contrast: isFeaturesActive(), expanded: expanded }">
    <div class="wrapper">
      <div class="content">
        <a href="/" class="logo" @click="logoClick">
          <inline-svg :src="`/images/v4/svg/${ logoName() }`" />
        </a>
        <nav>
          <div class="nav-left">
            <span v-if="isPricingActive()">Тарифы</span>
            <a v-else :href="`/pricing${urlQuery}`">Тарифы</a>
          </div>
          <div class="nav-right">
            <a class="nav-login-item" href="https://app.coverse.team/login">Войти</a>
          </div>
        </nav>
        <div class="buttons">
          <a target="_blank" class="ui-button-primary mod_size-s" :href="signupUrl">Регистрация</a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      scrolled: window.scrollY > 0,
      expanded: false,
      isPricingActive: () => {
        return this.$route.name === 'pricing';
      },
      isAIActive: () => {
        return this.$route.name === 'ai';
      },
      isFeaturesActive: () => {
        return this.$route.name === 'features';
      },
      logoName: () => {
        if (this.isAIActive()) {
          return 'logo-coverse.svg';
        }

        if (this.isFeaturesActive() && !this.expanded && !this.scrolled) {
          return 'logo-coverse-white.svg';
        }

        return 'logo-coverse-color.svg';
      }
    }
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 0;
    },
    onKeyDown(e) {
      if (e.key !== 'Escape' || !this.expanded) return;

      this.expanded = false;
    },
    onClick(e) {
      if (!e.target.closest('header') && this.expanded) {
        this.expanded = false;
      }
    },
    logoClick(e) {
      if (this.$route.name !== 'main') {
        e.preventDefault();

        window.location.href = `/${this.urlQuery}`;

        return;
      }

      if (window.scrollY > 0) {
        e.preventDefault();

        window.scroll({ top: 0 });

        return;
      }

      if (this.$route.name === 'main') {
        e.preventDefault();
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, true);
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('click', this.onClick);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll, true);
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('click', this.onClick);
  },
}
</script>

<style scoped lang="scss">
@import "@/../node_modules/bootstrap/scss/functions";
@import "@/../node_modules/bootstrap/scss/variables";
@import "@/../node_modules/bootstrap/scss/mixins";
@import "@/../node_modules/bootstrap/scss/utilities";
@import "@/styles/breakpoints";
@import "@/styles/button-dark";
@import "@/styles/button-volume";
@import "@/styles/button-primary";
@import "@/styles/button-primary-outline";

header {
  height: 70px;
  position: fixed;
  overflow: hidden;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
  transition: background 0.3s ease, box-shadow 0.3s ease, height 0.3s ease;
  display: flex;
  padding-top: 20px;
  flex-direction: column;

  .wrapper {
    max-width: 1240px;
    padding: 0 30px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: relative;
    align-self: flex-start;
  }

  .additional-navigation {
    max-width: 1130px;
    margin: 40px auto 0;
    padding: 0 30px;
    display: flex;
    visibility: hidden;
    transition: visibility .3s ease;

    &.expanded {
      visibility: visible;

      .additional-navigation-item {
        opacity: 1;
      }
    }

    .additional-navigation-item {
      text-decoration: none;
      max-height: 160px;
      outline: none;
      opacity: 0;
      color: #333334;
      width: 33.33333333333333%;
      padding: 22px 20px 44px 35px;
      border-radius: 5px;
      transition: background .3s ease, opacity .3s ease;
      cursor: pointer;

      .name {
        font-size: 20px;
        font-weight: 600;
        line-height: 30px;
        margin-bottom: 12px;
      }

      .description {
        font-size: 14px;
        font-weight: 400;
        line-height: 26px;
      }

      &:hover {
        background: rgba(235, 235, 253, 0.87);
      }
    }
  }

  &.floating {
    background: #fff;
    box-shadow: 0 2px 0 0 rgba(218, 232, 232, 0.4);
  }

  &.dark {
    color: #f8e5d8;

    .additional-navigation {
      .additional-navigation-item {
        color: #f8e5d8;

        &:hover {
          background: #333334;
        }
      }
    }

    nav {
      span {
        &.nav-product-item {
          svg {
            fill: #f8e5d8;
          }
        }
      }
    }

    &.expanded {
      background: #1a1a1b;
      box-shadow: 0 2px 0 0 rgba(51, 51, 52, 0.4);

      nav {
        span {
          &.nav-product-item {
            svg {
              fill: #f8e5d8;
            }
          }
        }
      }

      color: #f8e5d8;
    }

    &.floating {
      background: #19191a;

      &.expanded {
        background: #1a1a1b;
      }

      box-shadow: 0 2px 0 0 rgba(51, 51, 52, 0.4);
    }
  }

  &.expanded {
    height: 280px;
    background: #fff;
    box-shadow: 0 2px 0 0 rgba(218, 232, 232, 0.40), 0 5px 60px 0 rgba(0, 0, 0, 0.10);
  }

  &.contrast {
    color: #fff;

    &.expanded {
      nav {
        span {
          &.nav-product-item {
            svg {
              fill: #333334;
            }
          }
        }
      }

      color: #333334;
    }

    &.floating {
      nav {
        span {
          &.nav-product-item {
            svg {
              fill: #333334;
            }
          }
        }
      }

      color: #333334;
    }

    nav {
      span {
        &.nav-product-item {
          svg {
            fill: #fff;
          }
        }
      }
    }
  }

  .content {
    display: flex;
    width: 100%;

    .logo {
      width: 178px;

      svg {
        min-width: 178px;
        min-height: 30px;
      }
    }

    .buttons {
      margin-left: auto;

      & > * {
        font-size: 14px;
        width: 150px;
      }
    }
  }

  nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 0 20px 0 30px;
    align-items: center;

    .nav-right {
      margin-left: auto;
    }

    & > div {
      display: flex;
      flex-direction: row;
    }

    a, span {
      font-size: 14px;
      margin: 0 20px;
    }

    a {
      font-weight: 600;
      color: currentColor;
      transition: color 0.3s ease;
      text-decoration: none;

      &:hover {
        color: #ff5605;
      }
    }

    span {
      font-weight: 600;

      &.nav-product-item {
        cursor: pointer;
        transition: color .3s ease;
        position: relative;

        &.expanded {
          svg {
            transform: rotate(0);
          }
        }

        svg {
          width: 20px;
          height: 20px;
          transform: rotate(180deg);
          transition: transform .3s ease, fill .3s ease;
          margin-left: -2px;
        }

        &:hover {
          color: #ff5605;

          svg {
            fill: #ff5605 !important;
          }
        }
      }
    }
  }
}

@include media-breakpoint-down($size-desktop) {
  header {
    .wrapper {
      padding: 0 20px;
    }
  }
}

@include media-breakpoint-down($size-tablet) {
  header {
    .wrapper {
      padding: 0 30px;
    }

    &.expanded {
      height: 260px;
    }

    .additional-navigation {
      width: 100%; // check
      justify-content: space-between; // check
      padding: 0 15px;

      .additional-navigation-item {
        max-width: 236px; // check
        padding: 12px 15px 20px 15px;

        .name {
          font-size: 16px;
          line-height: 30px;
          margin-bottom: 2px;
        }

        .description {
          font-size: 12px;
          line-height: 22px;
        }
      }
    }

    nav {
      margin: 0 15px 0 25px;

      a, span {
        margin: 0 15px;
      }

      .nav-ai-item {
        display: none;
      }
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  header {
    height: 110px;
    align-items: flex-start;
    padding: 19px 0 0;

    .additional-navigation {
      display: block;
      padding: 0 10px;
      margin-top: 67px;

      .additional-navigation-item {
        height: 110px;
        padding: 9px 20px 25px 20px;
        width: 100%;
        display: block;
        max-width: unset;
        max-height: unset;
      }
    }

    &.dark {
      box-shadow: 0 2px 0 0 rgba(51, 51, 52, 0.4);
    }

    &.contrast {
      &:not(.floating) {
        box-shadow: none;
      }
    }

    &.expanded {
      height: 470px;
    }

    .wrapper {
      padding: 0 20px;
    }

    .content {
      .logo {
        width: 144px;

        svg {
          vertical-align: top;
          min-width: 144px;
          min-height: 23px;
        }
      }

      .buttons {
        & > * {
          width: 104px;
          height: 24px;
          line-height: 22px;
          vertical-align: top;
        }
      }
    }

    nav {
      left: 20px;
      right: 20px;
      display: flex;
      top: 53px;
      position: absolute;
      justify-content: flex-start;
      margin: 0 -17.5px;
      width: auto;

      .nav-right {
        margin-left: unset;
      }

      .nav-ai-item {
        display: none;
      }

      a, span {
        margin: 0 17.5px;
      }

      a {
        font-size: 14px;
      }

      span {
        font-size: 14px;
      }
    }
  }
}
</style>
